module.exports = __webpack_public_path__ + "img/aboutus.9c8fdd8.png";